import { render, staticRenderFns } from "./folder-header.vue?vue&type=template&id=62ec63ba&scoped=true&"
import script from "./folder-header.vue?vue&type=script&lang=js&"
export * from "./folder-header.vue?vue&type=script&lang=js&"
import style0 from "./folder-header.vue?vue&type=style&index=0&id=62ec63ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec63ba",
  null
  
)

export default component.exports